<div class="sections">
  <div class="card header-card">
    <div class="card-header display-flex billing-header">
      <div class="flex-start gap-3">
        <button class="btn btn-light" (click)="goBack()">
          <i class="fa fa-angle-left"></i>
          Back
        </button>
        <h5 class="mb-0">Azure Advisor Pillar Scores - {{ subscriptionId }}</h5>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body flow-auto">
      <div class="alert alert-danger" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <table class="table table-docs table-hover">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Pillar Name</th>
            <th>Category</th>
            <th>Score</th>
            <th>Last Refreshed</th>
            <th>Potential Score Increase</th>
          </tr>
        </thead>
        <tbody *ngIf="rows.length > 0">
          <tr *ngFor="let row of rows; let i = index">
            <td>{{ i + 1 }}</td>
            <td>
              <span class="nav-link p-0" (click)="openPillarRecommendations(row)">
                {{ row.pillar_name }}
              </span>
            </td>
            <td>{{ row.category }}</td>
            <td>{{ row.score }}</td>
            <td>{{ row.last_refreshed }}</td>
            <td>{{ row.potential_score_increase }}</td>
          </tr>
        </tbody>
        <tbody *ngIf="!loading && rows.length === 0">
          <tr>
            <td colspan="6" class="center">No data found</td>
          </tr>
        </tbody>
        <tbody *ngIf="loading">
          <tr>
            <td colspan="6" class="center">
              <div class="loader-wrap">
                <img src="assets/img/loading_2.svg" alt="loading scans" class="width-18" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
